export default __webpack_public_path__ + "static/media/Icon_Refresh.6c507e6f.svg";